module.exports = __webpack_public_path__ + "static/media/rw.b586ef69.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/rw.svg
// module id = 935
// module chunks = 0